// https://stackoverflow.com/a/14438954
// Get Unique Elements of an array. Similar to lodash unique function
export const getUniqueElements = (value: any, index: number, array: any[]) => {
  return array.indexOf(value) === index;
};